import React from "react";
import { Modal, Button, Typography, Box } from "@mui/material";

interface ConfirmModalProps {
  isOpen: boolean;
  credMessage: string;
  biMessage: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "16px",
};

const CredentialConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  credMessage,
  biMessage,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal open={isOpen} onClose={onCancel}>
      <Box sx={style}>
        <Typography variant="h6" component="div">
          Save Credential Type
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          You selected {credMessage}.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You {biMessage} Bilingual Language Specialization.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          These choices determine which version of the portfolio tool you will
          use. Are you sure these choices are correct?
        </Typography>
        <Box sx={buttonContainerStyle}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onCancel}
            sx={{ marginRight: "8px" }}
          >
            No
          </Button>
          <Button variant="contained" color="secondary" onClick={onConfirm}>
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CredentialConfirmModal;
